import { useParams } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { BookkeepersManagementIncidenceDocument } from 'generated/resources/graphql'

import createComputed from 'modules/core/hooks/createComputed'

import { useIncidences } from 'modules/bookkeepers/hooks/IncidencesContext'
import type { IncidenceQueryData } from 'modules/bookkeepers/hooks/useGetIncidences'
import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'

const getIncidence = createComputed(
  (incidenceId: string, incidences?: IncidenceQueryData[] | null) => {
    return incidences?.find((incidence) => incidence.id === incidenceId) || null
  }
)

const useGetCurrentIncidence = () => {
  const { id } = useParams()
  const incidenceId = id ?? ''
  const incidences = useIncidences()
  const incidenceData = getIncidence(incidenceId, incidences).get()
  const isBookkeeperView = useBookkeeperView()

  const pauseFetch = !incidenceId || !!incidenceData

  const { data, loading } = useQuery(BookkeepersManagementIncidenceDocument, {
    variables: {
      ids: [incidenceId],
    },
    context: {
      isBookkeeperView,
    },
    skip: pauseFetch,
    fetchPolicy: 'cache-and-network',
  })

  const fetchedIncidence = data?.bookkeepersManagement?.incidences[0]

  const incidence = fetchedIncidence || incidenceData

  return { loading, incidence }
}

export default useGetCurrentIncidence
